import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import biciq from "../assets/img/biciq.PNG";
import rick_morty from "../assets/img/rick-morti.PNG";
import potenciA from "../assets/img/poteci.PNG";
import cubicaje from "../assets/img/img cubi.PNG";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

/*Diseño web */
import aport from "../assets/img/Aportantes.png";
import fresa from "../assets/img/Fresa.png";
import hallo from "../assets/img/Haloween.png";
import homeC from "../assets/img/Home cliente.png";
import home from "../assets/img/Home.png";
import inicio from "../assets/img/Inicio.png";
import reciclaje from "../assets/img/reciclaje.png";
import slider from "../assets/img/Slider.png";
import colegio from "../assets/img/Homsade.png";
import gestion from "../assets/img/HomeG.png";

/*Diseño movil */
import healt from "../assets/img/Homee.png";
import tindog from "../assets/img/HomeT.png";
import uber from "../assets/img/HOmeU.png";
import manda from "../assets/img/Homex.png";
import sysmedica from "../assets/img/iPhone 14 & 15 Pro Max - 1.png";
import juegos from "../assets/img/Juegos.png";

export const Projects = () => {
  const projects = [
    {
      title: "Biciq",
      description: "Development",
      imgUrl: biciq,
    },
    {
      title: "Rick And Morty",
      description: "Design & Development",
      imgUrl: rick_morty,
    },
    {
      title: "PotenciAfro",
      description: "Design & Development",
      imgUrl: potenciA,
    },
    {
      title: "Sistema de cubicacion",
      description: "Design & Development",
      imgUrl: cubicaje,
    },
    // {
    //   title: "Business Startup",
    //   description: "Design & Development",
    //   imgUrl: projImg2,
    // },
    // {
    //   title: "Business Startup",
    //   description: "Design & Development",
    //   imgUrl: projImg3,
    // },
  ];

  const designWeb = [
    {
      title: "Sistema Funerario",
      description: "Design",
      imgUrl: aport,
    },
    {
      title: "Fruits",
      description: "Design",
      imgUrl: fresa,
    },
    {
      title: "Babys Halloween",
      description: "Design",
      imgUrl: hallo,
    },
    {
      title: "Dashboard PotenciAfro",
      description: "Design & Development",
      imgUrl: homeC,
    },
    {
      title: "Sitio Web PotenciAfro",
      description: "Design & Development",
      imgUrl: home,
    },
    {
      title: "MovieApp",
      description: "Design",
      imgUrl: inicio,
    },
    {
      title: "Eco PLay",
      description: "Design",
      imgUrl: reciclaje,
    },
    {
      title: "Concejos Comunitarios",
      description: "Design",
      imgUrl: slider,
    },
    {
      title: "Sistema de cubicacion",
      description: "Design",
      imgUrl: cubicaje,
    },
    {
      title: "Sistema Financiero",
      description: "Design",
      imgUrl: gestion,
    },
    {
      title: "Colegio San Jose de Timbiki",
      description: "Design",
      imgUrl: colegio,
    },
    // {
    //   title: "Business Startup",
    //   description: "Design & Development",
    //   imgUrl: projImg2,
    // },
    // {
    //   title: "Business Startup",
    //   description: "Design & Development",
    //   imgUrl: projImg3,
    // },
  ];

  const designMobile = [
    {
      title: "HealthHub",
      description: "Design",
      imgUrl: healt,
    },
    {
      title: "Tindog",
      description: "Design",
      imgUrl: tindog,
    },
    {
      title: "Uber Car",
      description: "Design",
      imgUrl: uber,
    },
    {
      title: "MandaYa!",
      description: "Design",
      imgUrl: manda,
    },
    {
      title: "SYSMEDICAL",
      description: "Design",
      imgUrl: sysmedica,
    },
    {
      title: "Juegos",
      description: "Design",
      imgUrl: juegos,
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__slideInDown" : ""
                  }
                >
                  <h2>Proyectos</h2>
                  <p>
                    A lo largo de mi carrera, he trabajado en proyectos que
                    combinan diseño creativo y desarrollo técnico, abarcando
                    desde aplicaciones web funcionales hasta interfaces
                    intuitivas y experiencias digitales impactantes. Cada uno de
                    ellos representa mi compromiso con la innovación, la calidad
                    y la atención al detalle. ¡Descubre cómo puedo aportar valor
                    a tus ideas!
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Desarrollo Web</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Diseño web</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Diseño movil</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {designWeb.map((desing, index) => {
                            return <ProjectCard key={index} {...desing} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="section">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Cumque quam, quod neque provident velit, rem
                          explicabo excepturi id illo molestiae blanditiis,
                          eligendi dicta officiis asperiores delectus quasi
                          inventore debitis quo.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row>
                          {designMobile.map((desing, index) => {
                            return <ProjectCard key={index} {...desing} />;
                          })}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
};
